import { render, staticRenderFns } from "./PlgSettingsApi.vue?vue&type=template&id=1463bd2b&"
import script from "./PlgSettingsApi.vue?vue&type=script&lang=js&"
export * from "./PlgSettingsApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports